import React from 'react';

const OP_STYLE = { color: '#D97706', fontWeight: 600 };

export const renderAdvancedSearchHighlight = (searchStr) => {
  if (!searchStr) return null;

  const hasAdvanced =
    / ET /.test(searchStr) || / OU /.test(searchStr) || / NON /.test(searchStr)
    || /"/.test(searchStr) || /[()]/.test(searchStr)
    || /\w\*(?:\s|$)/.test(searchStr) || /~\d/.test(searchStr);

  if (!hasAdvanced) return null;

  const spans = [];
  let pos = 0;
  let key = 0;

  while (pos < searchStr.length) {
    const char = searchStr[pos];

    if (char === '"') {
      const close = searchStr.indexOf('"', pos + 1);
      if (close !== -1) {
        const token = searchStr.slice(pos, close + 1);
        spans.push(<span key={key++} style={{ color: '#059669' }}>{token}</span>);
        pos = close + 1;
        continue;
      }
    }

    const op = [' ET ', ' OU ', ' NON '].find((candidate) => searchStr.startsWith(candidate, pos));
    if (op) {
      spans.push(<span key={key++} style={OP_STYLE}>{op}</span>);
      pos += op.length;
      continue;
    }

    if ('()'.includes(char)) {
      spans.push(<span key={key++} style={{ color: '#7C3AED', fontWeight: 600 }}>{char}</span>);
      pos += 1;
      continue;
    }

    const match = searchStr.slice(pos).match(/^[^\s()"']+/);
    if (match) {
      const token = match[0];
      const isSpecial = token.includes('*') || /~\d+$/.test(token);
      spans.push(
        <span key={key++} style={isSpecial ? { color: '#2563EB', fontWeight: 600 } : undefined}>
          {token}
        </span>
      );
      pos += token.length;
      continue;
    }

    spans.push(<span key={key++}>{char}</span>);
    pos += 1;
  }

  return spans;
};
